import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd);
  return data.url;
};

export const UploadButton = ({ onUploaded, multiple = false, testId, label = "Upload" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const onChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) onUploaded(await uploadImage(f));
      toast.success(files.length > 1 ? `${files.length} images uploaded` : "Image uploaded");
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
    e.target.value = "";
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/*" multiple={multiple} hidden onChange={onChange} data-testid={`${testId}-file-input`} />
      <button type="button" data-testid={testId} onClick={() => ref.current?.click()} disabled={busy} className="eyebrow inline-flex items-center gap-2 border border-[var(--mm-ink)] px-4 py-2.5 hover:bg-[var(--mm-ink)] hover:text-[var(--mm-cream)] transition-colors">
        <Upload size={13} /> {busy ? "Uploading…" : label}
      </button>
    </>
  );
};
